import React from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import constant from "../files/Constant.json";
import "../css/Portfolio.css";
const Portfolio = () => {
  return (
    <section id="Portfolio">
      <div className="port">
        <div className="heading_con">
          <h1 className="con_head">Some Things I’ve Built</h1>
        </div>
        <div className="portfolio_cont">
          {constant.projects.map((project, index) =>
            index % 2 === 0 ? (
              <div className="project">
                <div className="left">
                  <a href={project.link} target="__blank">
                    <img
                      src={project.image}
                      className="img"
                      alt="project_img"
                    />
                  </a>
                </div>
                <div className="right">
                  <a href={project.link} className="heading">
                    {project.title}
                  </a>
                  <p className="desc">{project.desc}</p>
                  <div className="skill_container">
                    {project.skills.map((skill) => (
                      <p>{skill}</p>
                    ))}
                  </div>
                  <div className="icons">
                    <a href={project.github} target="_blank" className="link">
                      <GitHubIcon />
                    </a>
                    <a href={project.link} target="_blank" className="link">
                      <OpenInNewIcon />
                    </a>
                  </div>
                </div>
              </div>
            ) : (
              <div className="project">
                <div className="left">
                  <a href={project.link} className="heading">
                    {project.title}
                  </a>
                  <p className="desc">{project.desc}</p>
                  <div className="skill_container">
                    {project.skills.map((skill) => (
                      <p>{skill}</p>
                    ))}
                  </div>
                  <div className="icons">
                    <a href={project.github} target="_blank" className="link">
                      <GitHubIcon />
                    </a>
                    <a href={project.link} target="_blank" className="link">
                      <OpenInNewIcon />
                    </a>
                  </div>
                </div>
                <div className="right">
                  <a href={project.link} target="__blank">
                    <img
                      src={project.image}
                      className="img"
                      alt="project_img"
                    />
                  </a>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
